import React from 'react'
import { Route } from 'react-router-dom'
import ManageDefaultRoutes from '../../ManageDefaultRoutes'
import Dashboard from '../../../pages/Operational/Workshop/Dashboard/Index'

const WorkshopRoutes = <>

    <Route path='workshop/*'>
        <Route path='' index element={<ManageDefaultRoutes path={"dashboard"} />} />
        <Route path='dashboard' element={<Dashboard />} />
    </Route>
</>

export default WorkshopRoutes